module.exports = __webpack_public_path__ + "img/logo-white.ff3fa0e6.png";